import { Capacitor } from '@capacitor/core';

// True when running inside the native Capacitor shell (Android/iOS app),
// as opposed to a normal browser. Used to switch to native auth flows and
// to hide web-only chrome (e.g. the site footer).
export const isNativeApp = () => Capacitor.isNativePlatform();
